import { Component } from '@verndale/core';

class WhitePapers extends Component {
  breakpoint = window.matchMedia('(min-width: 1280px)');
  offsetTop = 0;

  constructor(el: HTMLElement) {
    super(el);

    this.injectActionsMenu();
    this.handleBreakpoint();
    this.addEventListeners();
  }

  setupDefaults() {
    this.dom = {
      actionsMenu: this.el.querySelector<HTMLElement>('.page-actions-menu'),
      containerSidebar:
        this.el.querySelector<HTMLElement>('.container-sidebar'),
      containerContent:
        this.el.querySelector<HTMLElement>('.container-content'),
      actionsShareDropdown: this.el.querySelector<HTMLElement>(
        '.page-actions-menu__trigger--share'
      ),
      actionsMenuScroll: this.el.querySelectorAll(
        '.page-actions-menu__trigger[data-scroll-to]'
      ),
      progressBar: this.el.querySelector<HTMLElement>(
        '.page-actions-menu__progress'
      )
    };
  }

  injectActionsMenu() {
    if (this.dom.containerSidebar) {
      const containerSidebar = this.dom.containerSidebar as HTMLElement;
      const actionsMenu = this.dom.actionsMenu as HTMLElement;

      containerSidebar.appendChild(actionsMenu);
    }
  }

  addEventListeners() {
    document.addEventListener('scroll', this.handleScroll.bind(this));
    this.breakpoint.addEventListener(
      'change',
      this.handleBreakpoint.bind(this)
    );
    (this.dom.actionsShareDropdown as HTMLElement).addEventListener(
      'click',
      this.handleShareClick.bind(this)
    );

    (this.dom.actionsMenuScroll as NodeListOf<HTMLButtonElement>).forEach(
      option => {
        option.addEventListener(
          'click',
          this.handleActionsScrollClick.bind(this)
        );
      }
    );

    // handle click outside
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  handleBreakpoint() {
    this.offsetTop = this.breakpoint.matches ? 160 : 0;
  }

  handleScroll() {
    this.addStickyFunctionality();
    this.updateProgressBar();
  }

  handleShareClick(e: Event) {
    const target = e.currentTarget as HTMLButtonElement;

    if (target.getAttribute('aria-expanded') === 'false') {
      target.setAttribute('aria-expanded', 'true');
    } else {
      target.setAttribute('aria-expanded', 'false');
    }
  }

  handleActionsScrollClick(e: Event) {
    e.preventDefault();

    const target = e.currentTarget as HTMLButtonElement;
    const id = target.dataset.scrollTo;

    if (id) {
      if (id === 'top') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        const el = document.getElementById(id.replace('#', ''));

        if (el) {
          //scroll to that element + offset
          const y = el.getBoundingClientRect().top + window.scrollY - 150;

          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }
      }
    }
  }

  handleClickOutside(e: Event) {
    const target = e.target as HTMLElement;
    const shareDropdown = this.dom.actionsShareDropdown as HTMLElement;

    if (
      !shareDropdown.contains(target) &&
      shareDropdown.getAttribute('aria-expanded') === 'true'
    ) {
      shareDropdown.setAttribute('aria-expanded', 'false');
    }
  }

  addStickyFunctionality() {
    const { y } = this.el.getBoundingClientRect();
    const actionsMenu = this.dom.actionsMenu as HTMLDivElement;

    if (y <= this.offsetTop) {
      if (!actionsMenu.classList.contains('page-actions-menu--sticky')) {
        actionsMenu.classList.add('page-actions-menu--sticky');
      }
    } else if (actionsMenu.classList.contains('page-actions-menu--sticky')) {
      actionsMenu.classList.remove('page-actions-menu--sticky');
    }
  }

  updateProgressBar() {
    let container = this.el;

    if (this.dom.containerContent) {
      container = this.dom.containerContent as HTMLElement;
    }

    const scrollDistance = -(
      container.getBoundingClientRect().top - this.offsetTop
    );

    let progress =
      (scrollDistance /
        (container.getBoundingClientRect().height -
          document.documentElement.clientHeight +
          this.offsetTop)) *
      100;

    if (progress > 100) {
      progress = 100;
    } else if (progress < 0) {
      progress = 0;
    }

    (this.dom.progressBar as HTMLElement).style.width = `${progress}%`;
  }
}

export default WhitePapers;
